// @ts-nocheck
import {
    EVENT_TYPES_RECEIVED,
    UNSAVED_CHANGES,
    EVENT_STATUSES_RECEIVED,
    MBN_TYPES_RECEIVED,
    SELECTED_CITY_CHANGED,
    UPDATE_VERSION_RECEIVED,
    APP_VERSIONS_RECEIVED,
    APPLICATION_TYPE_CHANGED,
} from '../types';

const initialState = {
    hasUnsavedChanges: false,
    eventTypes: {
        list: [],
    },
    mbnTypes: {
        list: [],
    },
    tournaments: {},
    eventStatuses: {},
    selectedCityId: null,
    updateVersion: null,
    appVersions: [],
    filters: {
        applicationType: '',
    },
};

const general = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case UNSAVED_CHANGES: {
            return {
                ...state,
                hasUnsavedChanges: payload,
            };
        }
        case EVENT_TYPES_RECEIVED: {
            return {
                ...state,
                eventTypes: {
                    ...state.eventTypes,
                    list: payload,
                },
            };
        }
        case EVENT_STATUSES_RECEIVED: {
            return {
                ...state,
                eventStatuses: payload,
            };
        }
        case MBN_TYPES_RECEIVED: {
            return {
                ...state,
                mbnTypes: {
                    ...state.mbnTypes,
                    list: payload,
                },
            };
        }
        case SELECTED_CITY_CHANGED: {
            return {
                ...state,
                selectedCityId: payload,
            };
        }
        case UPDATE_VERSION_RECEIVED: {
            return {
                ...state,
                updateVersion: payload,
            };
        }
        case APP_VERSIONS_RECEIVED: {
            return {
                ...state,
                appVersions: payload,
            };
        }
        case APPLICATION_TYPE_CHANGED: {
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...payload,
                },
            };
        }

        default:
            return state;
    }
};

export default general;
